/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactSyncUpdateResult } from '../../models/api-response-contact-sync-update-result';
import { ContactSyncUpdateRequest } from '../../models/contact-sync-update-request';

export interface SyncUpdateContacts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ContactSyncUpdateRequest
}

export function syncUpdateContacts(http: HttpClient, rootUrl: string, params: SyncUpdateContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactSyncUpdateResult>> {
  const rb = new RequestBuilder(rootUrl, syncUpdateContacts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactSyncUpdateResult>;
    })
  );
}

syncUpdateContacts.PATH = '/v1/api/ui/contacts/sync-update';
